import { wellKnown } from '../../utils';
import env from '../env';

/**
 * Get the well known values. Cached per runtime.
 */
export const get = wellKnown.createGetter(env.SIGNIN_WELL_KNOWN_URI);
